import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse, SteamApp } from './items.entity';

@Injectable({
  providedIn: 'root'
})
export class InventoryService extends AbstractService {
  getInventory(): Observable<ApiResponse.InventoryResponse> {
    return this.get<ApiResponse.InventoryResponse>('/inventory/available');
  }

  sellItem(invItemId: number): Observable<void> {
    return this.post<void>(
      `/inventory/${ invItemId }/sell`,
      { },
      { throwError: true }
    );
  }

  sellMany(inventoryItems: number[]): Observable<void> {
    return this.post<void>(
      '/inventory/sell-many',
      { inventoryItems },
      { throwError: true }
    );
  }

  buyItems(shopItems: number[], inventoryItems: number[]): Observable<void> {
    return this.post<void>(
      '/items/buy',
      { shopItems, inventoryItems },
      { throwError: true }
    );
  }
}